const LegendChartSize = {
  textSize: 15,
};

export default LegendChartSize;
